import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranscriptSearched.meta';

export type UseTrackTranscriptSearchedParams = {
  clip_id: string;
  search_term: string;
};

export const useTrackTranscriptSearched = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranscriptSearched = useCallback(
    (params: UseTrackTranscriptSearchedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackTranscriptSearched };
};
